/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ConfirmAppSwitchPaymentRequest,
    ConfirmAppSwitchPaymentRequestFromJSON,
    ConfirmAppSwitchPaymentRequestToJSON,
} from '../models/ConfirmAppSwitchPaymentRequest';
import {
    type ErrorMessage,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
} from '../models/ErrorMessage';

export interface ConfirmAppSwitchPaymentOrRefundRequest {
    confirmAppSwitchPaymentRequest: ConfirmAppSwitchPaymentRequest;
}

/**
 * 
 */
export class SoftpayAppSwitchControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for confirmAppSwitchPaymentOrRefund without sending the request
     */
    async confirmAppSwitchPaymentOrRefundRequestOpts(requestParameters: ConfirmAppSwitchPaymentOrRefundRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['confirmAppSwitchPaymentRequest'] == null) {
            throw new runtime.RequiredError(
                'confirmAppSwitchPaymentRequest',
                'Required parameter "confirmAppSwitchPaymentRequest" was null or undefined when calling confirmAppSwitchPaymentOrRefund().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/softpay/confirm`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfirmAppSwitchPaymentRequestToJSON(requestParameters['confirmAppSwitchPaymentRequest']),
        };
    }

    /**
     */
    async confirmAppSwitchPaymentOrRefundRaw(requestParameters: ConfirmAppSwitchPaymentOrRefundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.confirmAppSwitchPaymentOrRefundRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async confirmAppSwitchPaymentOrRefund(requestParameters: ConfirmAppSwitchPaymentOrRefundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.confirmAppSwitchPaymentOrRefundRaw(requestParameters, initOverrides);
    }

}
